import React from 'react';
import { PlainText } from '@td-client-frontend/common';
import { useFormContext, get, Controller } from 'react-hook-form';

interface Props {
  children: React.ReactNode;
  name: string;
  label: string;
  value?: any;
  required?: boolean;
  readOnly?: boolean;
  className?: string;
  wrapperClasses?: string;
  labelClasses?: string;
  requiredIf?: string[];
  readOnlyFieldFormatter?: (value?: any, options?: any) => string;
  options?: { label: string; value: string }[];
  [x: string]: any;
}

export default function ComponentWrapperRHF({ children, requiredIf, ...rest }: Props) {
  const {
    name,
    label,
    value = '',
    required = false,
    readOnly = false,
    labelClasses = '',
    className = '',
    wrapperClasses = '',
    readOnlyFieldFormatter,
    options
  } = rest;
  const {
    getValues,
    formState: { errors }
  } = useFormContext();
  const lbl = required ? label.concat(' *') : label;
  let error = get(errors, name);

  if (readOnly || getValues('readOnly')) {
    const value = getValues(name);
    const formattedValue = readOnlyFieldFormatter?.(value, options) || value || '---';

    return (
      <PlainText
        name={name}
        value={formattedValue}
        label={label}
        className={className || wrapperClasses}
        labelClasses={labelClasses}
      />
    );
  }

  return (
    <Controller
      name={name}
      render={({ field }) => {
        const { ref, ...fieldRest } = field;
        if (requiredIf) {
          error =
            !field.value && requiredIf.some((field) => getValues(field))
              ? { message: `${label} dependent on another field` }
              : null;
        }
        return React.cloneElement(children as React.ReactElement, {
          ...rest,
          ...fieldRest,
          name,
          value: value || field.value,
          selected: field.value ? new Date(field.value) : null,
          checked: field.value,
          isError: !!error,
          error: error?.message,
          label: lbl
        });
      }}
    />
  );
}
